import { InputTextType } from '../Enum/InputTextType';
import Control from './Control';
export default class LabelControl extends Control {
    constructor(field) {
        super(field);
        this.type = InputTextType.text;
    }
    render() {
        return `<div class=form-control>
            <label for="${this.field.internalId}">${this.field.displayName}</label>` +
            (this.field.labelFieldSettings.text ? '<span class=hint-above>' + this.field.labelFieldSettings.text + '</span>' : '') +
            '</div>';
    }
    validate() {
        this.field.isValid = true;
        return true;
    }
}
